export default "__VITE_ASSET__Y0Ah1j2m__"